import HeaderImage from './headerImage.js';
export default HeaderImage;
